<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" class="ion-padding">
      <ion-grid fixed>
        <erklaerung-medgate @openChat="openChat('medgate')" :from="from" />
        <!-- <div class="ion-margin-top">
          <img src="@arag/assets/img/medgate_logo.svg" />
        </div> -->
        <ion-row
          v-if="from !== 'contact'"
          class="ion-align-items-center ion-margin-top"
        >
          <ion-col>
            <div class="c-cta">
              <ion-button
                v-if="from === 'secondopinion'"
                @click="openChat('medgate')"
                class="mt-5"
                >Jetzt Zweitmeinung einholen&nbsp;
                <ion-icon
                  :src="require('@lib/assets/icons/roodie-white.svg')"
                  slot="end"
                ></ion-icon>
              </ion-button>
              <ion-button
                v-else-if="from === 'dentist'"
                @click="openChat('medgate')"
                class="ion-text-wrap"
                >Jetzt Zahnarzt suchen&nbsp;
                <ion-icon
                  :src="require('@lib/assets/icons/roodie-white.svg')"
                  slot="end"
                ></ion-icon>
              </ion-button>
              <ion-button v-else @click="openChat('medgate')" class="mt-5"
                >Jetzt Facharzt/Klinik suchen&nbsp;
                <ion-icon
                  :src="require('@lib/assets/icons/roodie-white.svg')"
                  slot="end"
                ></ion-icon>
              </ion-button>
            </div>
          </ion-col>
          <!-- <ion-col class="ion-text-right">
            <img src="@arag/assets/img/medgate_logo.svg" width="130" />
          </ion-col> -->
        </ion-row>
        <div class="c-iframe ion-margin-top ion-padding-top">
          <div class="c-iframe__wrapper">
            <iframe
              class="c-iframe__video"
              width="560"
              height="315"
              src="https://www.youtube.com/embed/6bXoqniCoGc"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <ion-row v-if="from !== 'contact'" class="ion-margin-top">
          <ion-col>
            <div
              class="c-nugget u-bg-green"
              @click="$router.push({ path: '/medgate/anleitung' })"
            >
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/icon_roodie_call.svg') +
                    ')',
                }"
              ></div>
              <div class="c-nugget__label">
                So einfach geht's
              </div>
            </div>
          </ion-col>
          <ion-col>
            <div
              class="c-nugget u-bg-green"
              @click="$router.push({ name: 'medgate-kontakt' })"
            >
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/browser-anfrage.svg') +
                    ')',
                }"
              ></div>
              <div class="c-nugget__label">
                Termin buchen
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { chevronBack } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonIcon,
  IonButtons,
  IonGrid,
  IonRow,
  IonCol,
  IonBackButton,
} from "@ionic/vue";
import ErklaerungMedgate from "@/components/ErklaerungMedgate";
import { chat } from "@/mixins/chat";

export default {
  mixins: [chat],
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonIcon,
    IonButtons,
    IonGrid,
    IonRow,
    IonCol,
    ErklaerungMedgate,
    IonBackButton,
  },
  props: {
    from: {
      required: false,
      default: "contact",
    },
  },
  data() {
    return {};
  },
  setup() {
    return {
      chevronBack,
    };
  },
};
</script>

<style lang="scss" scoped></style>
